import Standout from './Standout.component';

export default Standout;